<template>
  <div class="login-container">
    <div class="login-form">
      <b-row class="mb-3" align-v="center">
        <b-col md="12" class="text-center">
          <b-img src="/img/neptunix-logo.png" alt="Mantraz Logo" class="login-logo"></b-img>
        </b-col>
      </b-row>
      <div class="login-form-card">
        <h3 class="mb-3 text-center">Forgot Password</h3>
        <p class="text-center mx-auto login-subtitle">Enter your email to request a password reset link.</p>
        <div class="form-container">
          <forgot-password-form @onSuccess="showModal" @onFailure="showModal" />
        </div>
      </div>
    </div>

    <!-- Modal -->
    <b-modal id="emailModal" title="Notification" ok-title="OK" @hide="resetModal">
      <p>{{ modalText }}</p>
    </b-modal>
  </div>
</template>

<script>
import ForgotPasswordForm from '@/components/auth/ForgotPasswordForm';
import mantrazImage from '@/assets/images/Mantraz.png';
import backgroundImage from '@/assets/images/background.jpg';
import AuthSvc from '@/services/AuthSvc';

export default {
  name: 'ForgotPassword',
  components: {
    ForgotPasswordForm,
  },
  data() {
    return {
      displayLoginForm: process.env.VUE_APP_ENABLE_FORM_LOGIN,
      mantrazLogo: mantrazImage,
      backgroundImageURL: backgroundImage,
      modalText: 'Please check your email for further information.',
    };
  },
  async mounted() {
    const userStatus = await this.getUserStatus();
    if (userStatus?.username) {
      await this.$router.push({ name: 'CompanyActiveSelection' });
    }
  },
  methods: {
    async getUserStatus() {
      try {
        const response = await AuthSvc.getUserStatus();
        return response.data;
      } catch (error) {
        console.error('Error fetching user status:', error);
        return null;
      }
    },
    showModal(txt) {
      // await this.$store.dispatch('auth/getUser');
      this.modalText = txt;
      this.$bvModal.show('emailModal'); // Menampilkan modal
    },
    onFailure() {
      this.modalText = 'Failed to send email. Please try again later.';
      this.$bvModal.show('emailModal');
    },
    resetModal() {
      this.$bvModal.hide('emailModal'); // Menampilkan modal
    },
  },
};
</script>

<style scoped>
/* Gaya yang diubah dan ditambahkan */
.login-form-card {
  padding: 35px;
  border-radius: 10px;
  /* Menggunakan box-shadow yang lebih modern dan lembut */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  max-width: 400px;
  margin: 0 auto;
}

.login-form-card h3 {
  font-weight: 600;
  color: #343a40;
}

.login-subtitle {
  font-size: 14px;
  /* Warna disesuaikan agar konsisten */
  color: #6c757d;
}

.form-container >>> .btn-primary {
  background: linear-gradient(to right, #e91e63, #9c27b0) !important;
  border: none !important;
  color: white !important;
  padding: 10px 20px !important;
  font-size: 1rem !important;
  font-weight: 500 !important;
  border-radius: 8px !important;
  transition: opacity 0.3s ease !important;
  width: 100%;
}

.form-container >>> .btn-primary:hover {
  opacity: 0.9;
}

.form-container >>> .btn-primary:disabled {
  background: #cccccc !important;
  cursor: not-allowed;
}

/* Gaya yang sudah ada (tidak diubah) */
.login-logo {
  width: 200px;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 0;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}

/* Layout utama diubah untuk centering */
.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center; /* Horizontally center */
  align-items: center; /* Vertically center */
  background-color: #f8f9fa; /* Background color for the whole page */
}

.login-form {
  width: 100%;
  max-width: 500px; /* Batasi lebar agar rapi di layar besar */
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* Border right dihapus karena tidak ada split screen lagi */
  /* Background dihapus/transparan karena container sudah punya warna */
}

.form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/* Bagian video dan styles terkait dihapus */

@media (max-width: 768px) {
  .login-form {
    padding: 20px;
    max-height: 100vh; /* Sesuaikan jika perlu scroll */
  }
}
</style>
